// GENERADO por `npm run brain:clients` a partir de shared/brain-profiles/*.json — NO editar a mano.
// Vista PÚBLICA del registro de perfiles (id, cliente, BU, preguntas): es lo único que importa el frontend.
// Lo demás (canales, casillas, spaces, eventos de Calendar) vive en index.ts y NO entra al bundle del front.
import type { BrainProfilePublic } from '../brain-profile-config';

export const BRAIN_PROFILE_PUBLIC: Readonly<Record<string, BrainProfilePublic>> = {
  "rappi.rts": {
    "id": "rappi.rts",
    "clientId": "rappi",
    "solution": "pml",
    "bu": {
      "name": "Rappitenderos (RTs)",
      "emoji": "🛵"
    }
  },
};
